
export function toQS(
  params?: Record<string, string | number | boolean | null | undefined>
): string {
  if (!params) return '';

  const entries = Object.entries(params).filter(
    ([, v]) => v !== undefined && v !== null && v !== ''
  );

  if (!entries.length) return '';

  const qs = new URLSearchParams();
  for (const [key, value] of entries) {
    qs.append(key, String(value));
  }

  return `?${qs.toString()}`;
}

export default toQS;
